import getPagePropertiesReduxUtil from 'modules/redux/utils/get-page-properties'
import getSchemaUtil from 'modules/schema/utils/get/index.js'
import { safeStringifyObjectUtil } from 'packages/src'

const TITLE = 'Gymaholic'
const TITLE_SUFFIX = ` - ${TITLE}`
const TITLE_LONG = 'Gymaholic App'
const TITLE_LONG_SUFFIX = ` - ${TITLE_LONG}`
const MAX_LENGTH = 60

/**
 * @param props
 * @param props.instance
 * @param props.title
 * @param props.pathname
 * @param props.description
 * @param props.state
 * @param props.intl
 * @return {{image: string, description: string, title: string, type: string, url: string, tags}}
 */
export default function getMetaAttributesRouteUtil (props) {
  const {
    instance,
    pathname,
    state,
    intl
  } = props
  let {
    title,
    description
  } = props

  const propsToPass = {
    instance,
    state,
    intl
  }
  const pagePropsFromInstance = getPagePropertiesReduxUtil({
    ...propsToPass,
    pathname
  })

  let schemaObj
  if (state) {
    schemaObj = (
      getSchemaUtil(propsToPass)
    )
  }

  let schema = null
  if (schemaObj) {
    schema = safeStringifyObjectUtil(schemaObj)
  }

  let {
    tags,
    image,
    url,
    type
  } = pagePropsFromInstance

  if (!url && BROWSER) {
    url = window.location.href
  }

  title = title || pagePropsFromInstance.title || ''
  description = description || pagePropsFromInstance.description || ''

  if (
    !title.includes(TITLE_LONG) &&
    (
      title + TITLE_LONG_SUFFIX
    ).length <= MAX_LENGTH
  ) {
    title += TITLE_LONG_SUFFIX
  }

  if (
    !title.includes(TITLE) &&
    (
      title + TITLE_SUFFIX
    ).length <= MAX_LENGTH
  ) {
    title += TITLE_SUFFIX
  }

  return {
    title,
    description,
    tags,
    image,
    url,
    type,
    schema
  }
}
